
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Додирните „Отвори у прегледачу…“`,
's182ab2d6c997515f': `Додајте га на Home Screen за широке могућности и лак приступ.`,
's224cbcec014ef6b5': `Притисните Share у навигационој траци`,
's233af3b7eb5e0364': `Додај на почетну страницу`,
's37a9e8aec5713460': `Више`,
's4c3161035f3a1413': `Притисните мени`,
's4e1e10a6ca408245': `Додирните "Add to Home Screen"`,
's6196153c4b0c1ea0': `Инсталирај`,
's633502f7cff4f847': `Отворите мени вашег прегледача`,
's681e399d63311fba': `Прикажи галерију`,
's6d14a4f70ba4e3cf': `Притисните мени ако нема иконе за дељење`,
's9c63a79ffcc2a3a3': `Притисните "Add to Home Screen"`,
'sa2d71bfd9525168d': `Притисните "Add to Dock"`,
'sa5ef80b4bb9b39f8': `Мање`,
'sb527eca1c1d7e7be': `Отворите мени уграђеног прегледача`,
'sba52286c21552a4e': `Инсталирајте га на вашем уређају за широке могућности и лак приступ.`,
'sc16e00a7a8b2fde2': `Назад`,
'sd18a5b85f599ff3c': `Отворите копирани линк у Safari-ју`,
'se72fc3a84f9b51c3': `Додирните за копирање линка`,
'se740f75b95a51807': `Додајте га у вашу Dock за широке могућности и лак приступ.`,
'sfa6c42cdf48d93d2': `Али овај прегледач не подржава ову функцију. Да бисте наставили, отворите линк у спољном прегледачу.`,
'sfb78526365796a41': `Притисните "View More" у Share менију`,
'sfea652f6580ff086': `Овај сајт има функционалност апликације.`,
's922329d6f6213590': `Add to Dock`,
'scdaf4bbff76674c8': `Add to Home Screen`,
    };
  